import axios from 'axios'

const getLetters = () => {
  let letters = '#abcdefghijklmnopqrstuvwxyz'.split('')
  let finalData = {}
  letters.forEach((item) => {
    finalData[item.toUpperCase()] = []
  })
  return finalData
}

export const combineWordsAndLetters = (words) => {
  let finalData = getLetters(words)
  words.forEach((item) => {
    const firstLetter = item.split('')[0]
    if (finalData.hasOwnProperty(firstLetter) || finalData.hasOwnProperty(firstLetter.toLowerCase)) {
      finalData[firstLetter].push(item)
    }
  })
  words.forEach((item) => {
    if (!Number.isNaN(parseInt(item.split('')[0]))) {
      finalData['#'].push(item)
    }
  })
  return finalData
}

export const combineWordsAndLettersinObject = (words) => {
  let finalData = getLetters(words)
  Object.values(words).forEach((item) => {
    const firstLetter = item.title.split('')[0]
    if (finalData.hasOwnProperty(firstLetter) || finalData.hasOwnProperty(firstLetter.toLowerCase)) {
      finalData[firstLetter].push(item)
    }
  })
  Object.values(words).forEach((item) => {
    if (!Number.isNaN(parseInt(item.title.split('')[0]))) {
      finalData['#'].push(item)
    }
  })
  return finalData
}

export const post = (r, rt, data) => {
  let formData = new FormData()
  formData.append('p', data)

  return new Promise((resolve, reject) => {
    let url = 'https://api1.webhr.co'

    axios({
      method: 'post',
      url: `${url}/?r=${r}&debug=0&rt=${rt}`,
      data: formData,
    })
      .then((sResponse) => {
        resolve(sResponse)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
